import styled from 'styled-components'
import { SkeletonElement, theme } from '@notino/react-styleguide'

import { NotinoBodyRegular, NotinoLabelRegular500, NotinoTitleSmall } from '../../../styles/helpers'

export const ProgressSection = styled.div<{ $edgeOffset?: boolean }>`
	${({ $edgeOffset }) =>
		$edgeOffset &&
		`
		margin: -24px -20px 0;
	`}
`

export const ProgressHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	padding: 16px 20px 0 20px;
`

export const ProgressDescription = styled.p`
	${NotinoBodyRegular};
	color: ${theme.color.text.secondary};
	margin: 4px 0 20px;
	padding: 0 20px;
`

export const ProgressTitle = styled.div`
	${NotinoTitleSmall};
	color: ${theme.color.text.primary};
`

export const ProgressTime = styled.div`
	${NotinoLabelRegular500};
	color: ${theme.color.text.highlight};
	flex-shrink: 0;
`

export const ProgressTrack = styled.div`
	height: 6px;
	margin-left: -4px;
	margin-right: -4px;
	background: ${theme.color.background.tertiary};
	overflow: hidden;
`

export const ProgressFill = styled.div<{ $progress: number }>`
	width: ${({ $progress }) => `${$progress}%`};
	height: 100%;
	border-radius: inherit;
	background: ${theme.color.background.highlight};
	transition: width 1s linear;
`

export const ProgressTrackSkeleton = styled(SkeletonElement)`
	height: 6px;
	width: 100%;
	border-radius: 0;
`

export const ProgressTitleSkeleton = styled(SkeletonElement)`
	height: 1.25rem;
	width: 8rem;
`

export const ProgressTimeSkeleton = styled(SkeletonElement)`
	height: 1.25rem;
	width: 3rem;
	flex-shrink: 0;
`
